/**
 * OAuth Provider Registry
 *
 * Single source of truth for OAuth provider configurations.
 * To add a new provider, add an entry here with the appropriate endpoint and credential extraction.
 */

import {
    GOOGLE_ADS_OFFLINE_CONVERSIONS_PARTNER_NAME,
    GOOGLE_ADS_ENHANCED_CONVERSIONS_PARTNER_NAME,
    GOOGLE_ADS_WEB_PARTNER_NAME,
    SNAP_CONVERSIONS_PARTNER_NAME,
    MICROSOFT_ADS_CONVERSIONS_PARTNER_NAME,
    TENCENT_PARTNER_NAME,
    TWITTER_PARTNER_NAME,
} from './consts';

const extractStandardCredentials = accessToken => ({
    loginId: accessToken.login_email,
    loginData: [{ refreshToken: accessToken.refresh_token }],
});

const googleOAuthConfig = {
    type: 'google',
    authEndpoint: '/adwordsauthorize',
    displayName: 'Google Ads',
    extractCredentials: extractStandardCredentials,
};

const extractTencentCredentials = accessToken => ({
    loginId: String(accessToken.account_id),
    loginData: [{ refreshToken: accessToken.refresh_token, qqNumber: accessToken.qq_number }],
});

const extractTwitterCredentials = accessToken => ({
    loginId: accessToken.username,
    loginData: [{ refreshToken: accessToken.oauth_token, secret: accessToken.oauth_token_secret }],
});

export const OAuthProviders = {
    [GOOGLE_ADS_OFFLINE_CONVERSIONS_PARTNER_NAME]: googleOAuthConfig,
    [GOOGLE_ADS_ENHANCED_CONVERSIONS_PARTNER_NAME]: googleOAuthConfig,
    [GOOGLE_ADS_WEB_PARTNER_NAME]: googleOAuthConfig,
    [SNAP_CONVERSIONS_PARTNER_NAME]: {
        type: 'snap',
        authEndpoint: '/snapchatauthorize',
        displayName: 'Snapchat',
        extractCredentials: extractStandardCredentials,
    },
    [MICROSOFT_ADS_CONVERSIONS_PARTNER_NAME]: {
        type: 'microsoft',
        authEndpoint: '/bingauthorize',
        displayName: 'Microsoft Ads',
        extractCredentials: extractStandardCredentials,
    },
    [TENCENT_PARTNER_NAME]: {
        type: 'tencent',
        authEndpoint: '/tencentauthorize',
        displayName: 'Tencent',
        extractCredentials: extractTencentCredentials,
    },
    [TWITTER_PARTNER_NAME]: {
        type: 'twitter',
        authEndpoint: '/twitterauthorize',
        displayName: 'Twitter',
        extractCredentials: extractTwitterCredentials,
    },
};

export const getOAuthProvider = partnerName => OAuthProviders[partnerName] || null;
